export default __webpack_public_path__ + "static/media/02AW1-2SEP66.fdb794fc.jpg";